// 네오메카 webRTC 버전 웹폰 컨트롤 관련

import $http from '@/http';
import logReport from '@/util/logReport';
import { getOpenMileRemoteAgentTelNumberList } from '@/constants/customInfo';

const state = () => {
  return {
    isWebPhoneLogin: false, // 네오메카 webRTC 웹폰 로그인 여부
    wpLoginTimer: null, // 5초마다 웹폰 로그인 여부 체크하기 위한 변수
    webPhoneWinObj: null // 웹폰 팝업 창 객체
  };
};

const getters = {
  isWebPhoneLogin: (state) => {
    return state.isWebPhoneLogin;
  }
};

const mutations = {
  setIsWebPhoneLogin(state, payload) {
    state.isWebPhoneLogin = payload;
  }
};

const actions = {
  async logInWebPhone({ state, dispatch, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    logReport.write(`[WEB-PHONE-LOGIN] telNumber: ${telNumber}`);

    if (!telNumber) return;
    if (!isNeoWebRtc) return;

    const localData = localStorage.getItem('call-agent-status');
    if (localData) {
      const callAgentStatus = JSON.parse(localData).status;
      if (callAgentStatus === '통화중') {
        return;
      }
    }

    const url = `${process.env.NEO_WEB_PHONE_URL}/NdcWebPhone/login/memberChk.do?e164_num=${telNumber}`;
    state.webPhoneWinObj = window.open(url, 'webPhone', 'width=1,height=1,left=-1000,top=-1000');
    logReport.write(`[WEB-PHONE-LOGIN] TRY LOGIN`);

    setTimeout(() => {
      dispatch('checkWebPhoneLogin');
    }, 1000);
  },

  async logOutWebPhone({ state, dispatch, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    logReport.write(`[WEB-PHONE-LOGOUT] telNumber: ${telNumber}`);

    if (!telNumber) return;
    if (!isNeoWebRtc) return;

    await dispatch('checkWebPhoneLogin');
    if (!state.isWebPhoneLogin) return;

    dispatch('closeWebPhone');

    const response = await $http({
      url: `${process.env.NEO_WEB_PHONE_URL}/NdcWebPhone/webphone/setPhoneStatusOff.do`,
      method: 'POST',
      data: {
        agent_dn: telNumber
      }
    });

    try {
      const { code, result } = response.data;
      if (code === 200 && result === 'OK') {
        logReport.write(`[WEB-PHONE-LOGOUT] SUCCESS`);
        await dispatch('checkWebPhoneLogin');
      } else {
        logReport.write(`[WEB-PHONE-LOGOUT-ERROR] status: ${result}, telNumber: ${telNumber}`);
      }
    } catch (error) {
      logReport.write('[WEB-PHONE-LOGOUT-ERROR]');
    }
  },

  logOutWebPhoneBeforeClose({ dispatch, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    logReport.write(`[WEB-PHONE-LOGOUT-BEFORE-CLOSE] telNumber: ${telNumber}`);
    if (!telNumber) return;
    if (!isNeoWebRtc) return;
    dispatch('closeWebPhone');
    fetch(`${process.env.NEO_WEB_PHONE_URL}/NdcWebPhone/webphone/setPhoneStatusOff.do`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        agent_dn: telNumber
      }),
      keepalive: true
    });
  },

  async checkWebPhoneLogin({ commit, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    if (!telNumber) return;
    if (!isNeoWebRtc) return;

    const response = await $http({
      url: `${process.env.NEO_WEB_PHONE_URL}/NdcWebPhone/webphone/checkStatus.do?agentDn=${telNumber}`,
      method: 'GET',
      NProgress: false
    });

    try {
      const { code, result } = response.data;
      if (code === 200 && result === 'OK') {
        commit('setIsWebPhoneLogin', response.data.Status === 1);
      } else {
        logReport.write(`[CHECK-WEB-PHONE-CONNECTION-ERROR] telNumber: ${telNumber}`);
      }
    } catch (error) {
      logReport.write(`[CHECK-WEB-PHONE-CONNECTION-ERROR] error: ${error}`);
    }
  },

  runWebPhoneLoginCheck({ state, dispatch, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    if (!isNeoWebRtc) return;
    if (state.wpLoginTimer) return; // 타이머 중복 생성 방지
    dispatch('checkWebPhoneLogin');
    state.wpLoginTimer = setInterval(() => {
      dispatch('checkWebPhoneLogin');
    }, 5000);
  },

  clearWebPhoneLoginCheck({ state, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    if (!isNeoWebRtc) return;
    if (state.wpLoginTimer) {
      clearInterval(state.wpLoginTimer);
      state.wpLoginTimer = null;
    }
  },

  closeWebPhone({ state, rootGetters }) {
    const { telNumber, isNeoWebRtc, getCallServerType } = rootGetters;

    // web cti 버전은 웹폰 사용 x
    // 단, 재택근무자는 웹폰을 띄워서 사용 가능하도록 예외 처리
    const isWebPhoneAgent = checkIsWebPhoneAgent(telNumber);
    const isNeoWebRtcCti = checkIsNeoWebRtcCti(getCallServerType);
    if (isNeoWebRtcCti && !isWebPhoneAgent) return;

    if (!isNeoWebRtc) return;

    const localData = localStorage.getItem('call-agent-status');
    if (localData) {
      const callAgentStatus = JSON.parse(localData).status;
      if (callAgentStatus === '통화중') {
        return;
      }
    }

    if (state.webPhoneWinObj) {
      state.webPhoneWinObj.close();
      state.webPhoneWinObj = null;
    } else {
      logReport.write('[WEB-PHONE-CLOSE] No webPhoneWinObj to close');
    }
  }
};

function checkIsWebPhoneAgent(telNumber) {
  const webPhoneAgentList = getOpenMileRemoteAgentTelNumberList();
  return webPhoneAgentList.indexOf(String(telNumber)) > -1;
}

function checkIsNeoWebRtcCti(getCallServerType) {
  return getCallServerType && getCallServerType.indexOf('NEO_WEB_RTC_CTI') > -1;
}

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/call/webPhone.js